import { FETCH_CATEGORIES, FETCH_LEVERANCIERS, TOGGLE_CATEGORY_FILTER, UPDATE_SEARCH_TERM } from "./types"

export const fetchCategories = () => {
    return {
        type: FETCH_CATEGORIES,
    }
}

export const fetchLeveranciers = () => {
    return {
        type: FETCH_LEVERANCIERS,
    }
}

export const toggleCategoryFilter = (category) => {
    return {
        type: TOGGLE_CATEGORY_FILTER,
    }
}

export const updateSearchTerm = () => {
    return {
        type: UPDATE_SEARCH_TERM,
    }
}

export default {
    FETCH_CATEGORIES() {
        return window.fetch("/wp-json/woltersperspublicaties/wie-levert-wat/categories")
            .then ((response) => {
                if (response.ok) {
					return response.json();
				}
				throw new Error('Could not fetch categories');
            });
    },
    FETCH_LEVERANCIERS() {
        return window.fetch("/wp-json/woltersperspublicaties/wie-levert-wat/leveranciers")
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error ('Could not fetch leveranciers');
            })
    },
    TOGGLE_CATEGORY_FILTER(category, checked) {
        return (category, checked);
    },
    UPDATE_SEARCH_TERM(term) {
        return {term};
    }
}